import React, { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
// import { GlobalContext } from "../../../context/Context";
import { useApiCall } from "../../../custom-hooks/api-call";
import LeftSidePopupLayout from "../../../popup/modal-layout";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../form/form-layout";
import XCloseIcon from "../../../icons/x-close";
import { GlobalContext } from "../../../../context/Context";
import Swal from "sweetalert2";

const MarkCompleted = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  followUpID = {},
  schedules = [],
}) => {
  const apiCall = useApiCall();

  useEffect(() => {
    console.log("schedules", schedules);
  }, []);

  // const [newSchedules, setNewSchedules] = useState(schedules || []);

  const validationSchema = yup.object({
    reason: yup
      .string("This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      reason: "",
    },

    validationSchema: validationSchema,

    onSubmit: async (values) => {
      try {
        let data = {
          id: followUpID,
          status: "completed",
          reason: values?.reason, //"pending"
        };

        let apiRes = await apiCall({
          method: "post",
          url: "activities/update-followup-status",
          data: data,
        });

        const updatedSchedules = schedules?.map((f) =>
          f.id == followUpID
            ? { ...f, status: "completed", reason: values?.reason }
            : f,
        );

        formik.resetForm();

        onSubmit(
          apiRes?.message || `Request Submitted`,
          updatedSchedules, // ✅ correct updated data
        );

        formik.resetForm();
      } catch (error) {
        onError(error?.message || `internal server error`);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0 !h-[300px]`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>Mark Completed</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} text-xl flex shrink-0 cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* Reason */}
                  <FeildWraper width="100%">
                    <FormLabel required>Reason</FormLabel>
                    <input
                      name="reason"
                      value={formik.values.reason}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter Reason"
                    />
                    {formik.touched.reason && formik.errors.reason && (
                      <FeildError>{formik.errors.reason}</FeildError>
                    )}
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot} flex justify-end`}>
          <div className=" w-[50%] flex gap-2">

          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button
            type="submit"
            className={`${Style.dcmb__submit} disabled:!opacity-70 disabled:!cursor-not-allowed`}
          >
            Submit
          </button>
          </div>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default MarkCompleted;
